import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { AnalyticsService } from 'services';
import { LawyersIcon, UsersIcon } from 'assets/icons';
import { DateRange } from '../hooks/use-date-range';
import { buildDateCategoryAxis } from '../utils/chart-axis';
import { buildGradientFill } from '../utils/chart-style';
import SectionHeader from '../components/section-header';
import ChartCard from '../components/chart-card';
import KpiCard from '../components/kpi-card';

interface Props {
  range: DateRange;
}

const sum = (rows: any[], key: string) => rows.reduce((acc, r) => acc + (r[key] || 0), 0);

const UsersSection = ({ range }: Props) => {
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState<any[]>([]);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      setLoading(true);
      try {
        const res: any = await AnalyticsService.users.registrationHistory({
          ...range,
          withoutLoading: true,
        });
        if (!cancelled) setRows(res || []);
      } catch (error) {
        console.error('[UsersSection] Error cargando histórico de registros', error);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [range.startDate, range.endDate]);

  const categories = rows.map((r) => moment(r.date).format('DD/MM'));
  const lawyersTotal = sum(rows, 'lawyers');
  const clientsTotal = sum(rows, 'clients');

  return (
    <section className='analytics-section'>
      <SectionHeader
        title='Usuarios'
        subtitle='Registros diarios de clientes y abogados en el rango seleccionado'
      />
      <div className='grid grid-asym'>
        <ChartCard
          title='Registros por día'
          loading={loading}
          empty={!loading && rows.length === 0}
          type='area'
          height={380}
          series={[
            { name: 'Abogados', data: rows.map((r) => r.lawyers) },
            { name: 'Clientes', data: rows.map((r) => r.clients) },
          ]}
          options={{
            chart: { toolbar: { show: false }, zoom: { enabled: false } },
            dataLabels: { enabled: false },
            stroke: { curve: 'smooth', width: 3 },
            xaxis: buildDateCategoryAxis(categories),
            legend: { position: 'top', horizontalAlign: 'right' },
            ...buildGradientFill(['#7f00b2', '#49aa43']),
          }}
        />
        <div className='side-stack'>
          <KpiCard
            label='Abogados registrados'
            value={lawyersTotal}
            icon={LawyersIcon}
            accent='purple'
          />
          <KpiCard
            label='Clientes registrados'
            value={clientsTotal}
            icon={UsersIcon}
            accent='green'
          />
        </div>
      </div>
    </section>
  );
};

export default UsersSection;
